import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { RouterProps, Link as ReactRouterLink } from "react-router-dom";
import "./Login.css";
import backgroundImage from "../../assets/images/Background.png";

import {
  Input,
  Button,
  Box,
  Heading,
  FormControl,
  Alert,
  Spinner,
  Link,
  Flex,
  InputGroup,
  InputRightElement,
  IconButton,
  VStack,
  Text,
  FormLabel
} from "@chakra-ui/react";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { useAuth } from "../../utils/auth-context";
import { useAdminStore } from "../../store/adminStore";

//Initialing the Objects for Formik Hook
const initialValues = {
  username: "",
  password: ""
};

const validate = (values: { username: string; password: any }) => {
  const errors: { username?: string; password?: string } = {};
  if (!values.username) {
    errors.username = " Email Required*";
  }
  // else if (
  //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.username)
  // ) {
  //   errors.username = "Invalid Email Format*";
  // }

  if (!values.password) {
    errors.password = "Password is Required*";
  }

  return errors;
};

interface ErrormessageType {
  message: string;
}

export const Login = (_props: RouterProps) => {
  const { login } = useAuth();
  const [error, setError] = useState<ErrormessageType | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const dispatch = useAdminStore(state => state.changeFilter);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const onSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      if (login) {
        await login(values);
        setIsLoading(false);
      }
    } catch (e) {
      setError(e as ErrormessageType);
      setIsLoading(false);
    }
  };

  //Creating Hook
  const formik = useFormik({
    initialValues,
    onSubmit,
    validate
  });

  useEffect(() => {
    let timerId: unknown = null;
    if (error) {
      timerId = setTimeout(() => {
        setError(null);
      }, 30000);
    }
    return () => {
      clearTimeout(timerId as any);
    };
  }, [error]);

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        backgroundImage={`url(${backgroundImage})`}
        backgroundSize="cover"
        h="100%"
        position="relative"
      >
        <Box
          boxShadow="lg"
          border="1px solid"
          borderRadius="8"
          borderColor="gray.200"
          height="500px"
          w="500px"
          m="auto"
          textAlign="center"
          bg="white"
        >
          <Flex
            direction="column"
            height="100%"
            justifyContent="space-evenly"
            p="12"
          >
            <Box marginBottom={"20px"}>
              <Heading
                fontSize="24px"
                color="#05103D"
                fontWeight="700"
                marginBottom={"10px"}
              >
                Welcome
              </Heading>
              <Text fontSize={"13px"} color={"#6A6B6C"}>
                Log in with your username or email address.
              </Text>
            </Box>
            {/* <Button onClick={Message}></Button> */}
            <form
              onSubmit={formik.handleSubmit}
              onChange={() => setError(null)}
            >
              <VStack spacing="30px">
                <FormControl>
                  <FormLabel color="#6A6B6C" fontSize={"13px"}>
                    Email address
                  </FormLabel>
                  <Input
                    type="text"
                    placeholder="Enter email address"
                    id="name"
                    fontSize={"13px"}
                    name="username"
                    color={"#424B6C"}
                    bg="faintBlue"
                    onChange={formik.handleChange}
                    value={formik.values.username}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.username && formik.errors.username ? (
                    <span className="error" style={{ fontSize: "13px" }}>
                      {" "}
                      {formik.errors.username}
                    </span>
                  ) : null}
                </FormControl>
                <FormControl>
                  <FormLabel color="#6A6B6C" fontSize={"13px"}>
                    Password
                  </FormLabel>
                  <InputGroup>
                    <Input
                      type={passwordShown ? "text" : "password"}
                      id="password"
                      name="password"
                      onChange={formik.handleChange}
                      value={formik.values.password}
                      color={"#424B6C"}
                      fontSize={"13px"}
                      onBlur={formik.handleBlur}
                      placeholder="Enter password"
                      bg="faintBlue"
                    />
                    <InputRightElement>
                      <IconButton
                        variant="unstyled"
                        colorScheme="blue"
                        aria-label="Search database"
                        color=" darkGray"
                        icon={
                          passwordShown ? (
                            <AiOutlineEyeInvisible size={20} />
                          ) : (
                            <AiOutlineEye size={20} />
                          )
                        }
                        onClick={togglePasswordVisiblity}
                        _focus={{ border: "none" }}
                      />
                    </InputRightElement>
                  </InputGroup>
                  {formik.touched.password && formik.errors.password ? (
                    <span className="error" style={{ fontSize: "13px" }}>
                      {" "}
                      {formik.errors.password}
                    </span>
                  ) : null}
                </FormControl>
              </VStack>

              <Flex mt={"15px"} w="100%" justifyContent="flex-end">
                {/* <Link
                  size="sm"
                  color="primary"
                  fontWeight="bold"
                  as={ReactRouterLink}
                  to="/register"
                >
                  Set Password
                </Link> */}
                <Link
                  size="sm"
                  color="primary"
                  style={{ fontSize: "13px" }}
                  fontWeight="bold"
                  as={ReactRouterLink}
                  to="/forget-password"
                >
                  Forgot password?
                </Link>
              </Flex>
              {error ? (
                <Alert
                  background={"none"}
                  color={"red"}
                  fontSize={"13px"}
                  status="error"
                  p={"0px"}
                >
                  {error}{" "}
                </Alert>
              ) : null}

              <Flex justifyContent={"flex-end"}>
                <Button
                  mt={"13px"}
                  w="100%"
                  type="submit"
                  size="md"
                  style={{ fontSize: "13px" }}
                  p="auto"
                  height={"40px"}
                  _hover={{
                    background: "#95c7e3e8"
                  }}
                  onClick={() => {
                    dispatch({ type: "clearAll" });
                  }}
                >
                  {isLoading ? <Spinner /> : "Log in"}
                </Button>
              </Flex>
            </form>
          </Flex>
        </Box>
      </Box>
      <VStack
        position="absolute"
        top="40%"
        right="12%"
        color="primary"
        opacity="15%"
        alignItems="start"
      >
        <Heading size="xl">My</Heading>
        <Heading size="xl">People</Heading>
        <Heading size="xl">Strategy</Heading>
      </VStack>
    </>
  );
};
